<template>
    <div>
        <div ref="chartWrapper" class="w-100 h-100">
            <ejs-chart :id="'chart_'+dashboardWidgetConfigurationId"
                       :primaryXAxis="primaryXAxis"
                       :primaryYAxis="primaryYAxis"
                       :legendSettings="legendSettings"
                       :tooltip="tooltip"
                       :height="chartHeight"
                       :width="chartWidth"
                       v-if="chartDataLoaded">
                <e-series-collection>
                    <e-series :dataSource='seriesData' :type='getCurrentChartType()' xName="day" yName="monitor" name='Monitor'> </e-series>
                    <e-series :dataSource='seriesData' :type='getCurrentChartType()' xName='day' yName='stenographer' name='Stenographer'> </e-series>
                    <e-series :dataSource='seriesData' :type='getCurrentChartType()' xName='day' yName='transcriber' name='Transcriber'> </e-series>
                </e-series-collection>
            </ejs-chart>
        </div>

        <b-modal v-model="modalVisible" title="Settings" @ok="handleModalOk">
            <b-form-group label="Title" label-for="widgetTitle">
                <b-form-input name="widgetTitle" v-model="widgetTitle"></b-form-input>
            </b-form-group>

            <b-form-group label="Court/Tribunal/Other"
                          label-for="courtRegistryId">
                <select2 name="courtRegistryId"
                         :options="allCourtRegistries"
                         multiple
                         key-property="courtRegistryId"
                         text-property="name"
                         v-model="currentConfiguration.courtRegistryIds">
                </select2>
            </b-form-group>
            <b-form-group label="Organisation"
                          label-for="interviewOrganisatoinId">
                <select2 name="interviewOrganisatoinId"
                         :options="allInterviewOrganisations"
                         multiple
                         key-property="interviewOrganisationId"
                         text-property="name"
                         v-model="currentConfiguration.interviewOrganisationIds">
                </select2>
            </b-form-group>
        </b-modal>

    </div>
</template>
<script>
    import Vue from "vue";
    import { ChartPlugin, ColumnSeries, LineSeries, Category, Legend, Tooltip } from "@syncfusion/ej2-vue-charts";
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { BootstrapVueIcons } from 'bootstrap-vue';
    import axios from 'axios';

    import Visibility from 'visibilityjs';

    import ErrorsMixin from '../../../mixins/ErrorsMixin';

    Vue.use(ChartPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(BootstrapVueIcons);

    export default {
        name: 'AvailabilityWidget',
        mixins: [ErrorsMixin],
        props: {
            dashboardWidgetConfigurationId: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            configuration: {
                type: Object,
                default: null
            },
            widgetMode: {
                type: String,
                default: 'view'
            },
            selectedTimeRange: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                timer: null,
                refreshIntervalInMilliseconds: 60000,

                currentConfiguration: this.configuration ? this.configuration : { courtRegistryIds: null, interviewOrganisationIds: null },
                allCourtRegistries: null,
                allInterviewOrganisations: null,
                modalVisible: false,
                widgetTitle: this.title,
                
                seriesData: [],
                chartType: 'Column',
                chartLabel: "Saff availability",
                tooltip: { enable: true, format: '${point.x}: ${point.y}' },
                chartPeriodInDays: 7,
                primaryXAxis: {
                    valueType: 'Category',
                    title: 'Day of week',
                    titleStyle: {
                        size: '14px', color: '#444',
                        fontFamily: 'Segoe UI', fontWeight: ''
                    },
                    labelStyle: {
                        size: '12px', color: '#888',
                        fontFamily: 'Segoe UI', fontWeight: ''
                    }
                },
                primaryYAxis: {
                    valueType: 'Double',
                    rangePadding: 'Auto',
                    title: 'Nr. of staff',
                    interval: 2,
                    titleStyle: {
                        size: '14px', color: '#444',
                        fontFamily: 'Segoe UI', fontWeight: ''
                    },
                    labelStyle: {
                        size: '12px', color: '#888',
                        fontFamily: 'Segoe UI', fontWeight: ''
                    }
                },
                availabilityWeekData: null,
                animation: { enable: false },
                legendSettings: { 
                    visible: true,
                    position: 'Top'
                },
                chartDataLoaded: false,

                resizeObserver: null,
                chartHeight: '',
                chartWidth: '',
            };
        },

        provide: {
            chart: [ColumnSeries, LineSeries, Category, Legend, Tooltip]
        },
        watch: {
            selectedTimeRange: function () {
                this.reloadData();
            }
        },

        methods: {

            handleModalOk() {
                this.modalVisible = false;
                this.$emit('configurationChanged', this.widgetTitle, this.currentConfiguration);
            },
                        
            toggleChartType: function () {
                if (this.chartType == 'Column') this.chartType = 'Line'; else this.chartType = 'Column';
            }, 

            getCurrentChartType: function () { 
                return this.chartType;
            },
            loadData: function () {
                if (this.dashboardWidgetConfigurationId) {
                    var url = this.$urlHelper.getApiUrl('dashboardwidget', 'data', ['staffavailability', this.dashboardWidgetConfigurationId, 'null']);
                    // providing the null at the end of the url indicates that this widget does not want to deal with time ranges
                    axios
                        .get(url)
                        .then(response => {
                            var maxCount = 0;
                            response.data.days.forEach(day => {
                                if (day.monitor && day.monitor > maxCount) maxCount = day.monitor;
                                if (day.stenographer && day.stenographer > maxCount) maxCount = day.stenographer;
                                if (day.transcriber && day.transcriber > maxCount) maxCount = day.transcriber;
                            });
                            var interval = 2;
                            if (maxCount <= 10) interval = 2;
                            else if (maxCount <= 30) interval = 4;
                            else if (maxCount <= 50) interval = 6;
                            else interval = 10;
                            if (this.primaryYAxis.interval != interval) {
                                this.chartDataLoaded = false; //this will fully re-draw the chart
                                this.primaryYAxis.interval = interval;
                            }
                            this.seriesData = response.data.days;
                            this.$nextTick(() => {
                                this.chartDataLoaded = true;
                            });
                        })
                        .catch(ex => {
                            console.log(JSON.stringify(ex));
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
            },

            reloadData: function () {
                if (this.widgetMode == 'view') {
                    this.loadData();
                }
            },
            
            editConfiguration: function () {
                if ((this.allCourtRegistries == null) && (this.allInterviewOrganisations == null)) {
                    var promises = [];
                    var url = this.$urlHelper.getApiUrl('courtregistry', 'all');
                    promises.push(
                        axios
                            .get(url)
                            .then(response => {
                                this.allCourtRegistries = response.data;

                            }));
                    url = this.$urlHelper.getApiUrl('intervieworganisation', 'all');
                    promises.push(
                        axios
                            .get(url)
                            .then(response => {
                                this.allInterviewOrganisations = response.data;
                            }));
                    Promise
                        .all(promises)
                        .then(() => {
                            this.modalVisible = true;
                        });
                } else {
                    this.modalVisible = true;
                }
            },

            onResize: function () {
                var chartWrapperSize = this.$refs.chartWrapper.getBoundingClientRect();
                this.chartWidth = Math.trunc(chartWrapperSize.width) + "px";
                this.chartHeight = Math.trunc(chartWrapperSize.height) + "px";
            }
        },

        mounted: function () {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this.$refs.chartWrapper);
            this.loadData();
            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadData);
        },
        beforeDestroy() {
            this.resizeObserver.unobserve(this.$refs.chartWrapper);
        }
    }
</script>